module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( error ) { 
__p+='\n\n	<p class="interest-filter-error">\n		'+
((__t=( error ))==null?'':__t)+
'\n	</p>\n\n';
 } else { 
__p+='\n\n	';
 if ( loading ) { 
__p+='\n\n		<p class="interest-filter-loading">\n			Interessen werden geladen, einen Moment bitte...\n		</p>\n\n	';
 } else { 
__p+='\n\n		';
 if ( local ) { 
__p+='\n\n			<p>Ergebnisse '+
((__t=( totalCount ))==null?'':__t)+
'</p>\n			<p>\n				Tags '+
((__t=( selectedTags.join(", ") ))==null?'':__t)+
'\n				<button class="tags-reset">Reset selectedTags</button>\n				<button class="tags-submit">Submit</button>\n			</p>\n\n		';
 } 
__p+='\n\n		<div class="interest-filter">\n\n			';
 _.each(tagGroups, function(group) { 
__p+='\n				<div class="grid-box">\n					<h2>'+
((__t=( group.name ))==null?'':__t)+
'</h2>\n\n					<div class="grid-box-tags">\n						';
 _.each(group.tags, function(tag) { 
__p+='\n						<div class="tag-box '+
((__t=( selectedTags.indexOf(tag.id) !== -1 ? "tag-selected" : "" ))==null?'':__t)+
' '+
((__t=( tag.count === 0 ? "tag-empty" : "" ))==null?'':__t)+
'" title="Tag '+
((__t=( tag.id ))==null?'':__t)+
'" data-tag="'+
((__t=( tag.id ))==null?'':__t)+
'">\n							<div class="tag-count">'+
((__t=( tag.count ))==null?'':__t)+
'</div>\n							<div class="tag-name">'+
((__t=( tag.tag ))==null?'':__t)+
'</div>\n							<div class="tag-info">'+
((__t=( tag.info ))==null?'':__t)+
'</div>\n							<img class="tag-image" src="'+
((__t=( tag.image ))==null?'':__t)+
'">\n							';
 if ( selectedTags.indexOf(tag.id) !== -1 ) { 
__p+='\n								<div class="tag-selected-overlay"></div>\n							';
 } 
__p+='\n						</div>\n						';
 }) 
__p+='\n					</div>\n\n				</div>\n			';
 }) 
__p+='\n		</div>\n\n	';
 } 
__p+='\n\n';
 } 
__p+='\n\n\n';
 if ( local ) { 
__p+='\n<style type="text/css" media="screen">\n.interest-filter {\n	display: flex;\n	width: 100%;\n	justify-content: center;\n}\n.interest-filter .grid-box {\n	padding: 20px;\n	width: calc(100% / 3);\n	border-right: 1px solid #b1b4a4;\n}\n.interest-filter .grid-box:last-child {\n	border-right: 0;\n}\n\n.interest-filter .grid-box h2 {\n	text-transform: uppercase;\n	color: #b1b4a4;\n	font-weight: 200;\n	font-size: 14pt;\n	padding-left: 10px;\n}\n.interest-filter .grid-box-tags {\n	display: flex;\n	flex-flow: row wrap;\n}\n\n.tag-box {\n	display: flex;\n	width: 150px;\n	cursor: pointer;\n	padding: 5px;\n	flex-flow: row wrap;\n	margin: 5px;\n	position: relative;\n}\n.tag-box.tag-empty {\n	opacity: 0.5;\n	cursor: default;\n}\n.tag-box.tag-selected {\n	background: #ddd;\n}\n\n\n.tag-box .tag-image {\n	width: 100%; height: 80px; border: 3px solid #ccc; border-radius: 8px;\n}\n.tag-box.tag-selected .tag-image {\n	border: 3px solid white;\n}\n.tag-box .tag-selected-overlay {\n	position: absolute;\n	top: 5px;\n	left: 10px;\n	width: 30px;\n	height: 30px;\n	background: url(demo-img/checked.png) no-repeat;\n}\n\n.tag-box .tag-name { width: 85%; font-style: italic; }\n.tag-box .tag-count { width: 15%; text-align: right; color: #aaa; font-size: 90% }\n\n.interest-filter-error {\n	text-align: center;\n	color: #9C3300;\n	font-size: 14pt;\n}\n\n.interest-filter-loading {\n	text-align: center;\n	color: #0C5B03;\n	font-size: 14pt;\n}\n\n</style>\n\n';
 } 
__p+='';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/interest-filter.html
// module id = 78
// module chunks = 0